import { Injectable } from '@angular/core';
import { Router, NavigationExtras } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class PrintService {

  constructor(private router: Router) {}

  /**
   * Ouvre une route Angular dans un nouvel onglet et déclenche l'impression
   * @param commands - Route Angular (ex: ['/print/order'])
   * @param extras - NavigationExtras pour queryParams, fragment, etc.
   * @param autoClose - optionnel, ferme automatiquement l'onglet après impression
   */
  openPrint(commands: any[], extras?: NavigationExtras, autoClose: boolean = false) {
 // Retirer le slash initial de chaque segment
    commands = commands.map(cmd => (typeof cmd === 'string' && cmd.startsWith('/') ? cmd.slice(1) : cmd));

    // Génère l’URL Angular propre
    const urlTree = this.router.createUrlTree(commands, extras);

    // Récupère le base href
    const baseHref = document.querySelector('base')?.getAttribute('href') || '/';

    // Construit l’URL finale complète
    const url = window.location.origin + baseHref.replace(/\/$/, '') + this.router.serializeUrl(urlTree);

    // Ouvre un nouvel onglet
    const win = window.open(url, '_blank');

    if (win) {
      // Vérifie le chargement du DOM avant de lancer print()
      const interval = setInterval(() => {
        try {
          if (win.document.readyState === 'complete') {
            clearInterval(interval);
            win.focus();       // met le focus sur l'onglet
            win.print();       // lance la prévisualisation du navigateur
            if (autoClose) {
              win.close();     // ferme l'onglet après impression si demandé
            }
          }
        } catch (e) {
          // ignore les erreurs cross-origin (rare en Angular)
        }
      }, 100);
    } else {
      console.error('Impossible d’ouvrir un nouvel onglet pour l’impression.');
    }
  }
}